import React, { useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Discount from "../../../assets/discount-apply.svg";
import LoadingComponent from "../../LoadingComponent";
import { fireGtagEvent } from "../../../utils/google-analytics";
import { ErrorTemplate } from "../../../templates";
import { useApplyDiscountsMutation } from "../../../hooks";

function CouponDiscount() {
  const location = useLocation();

  const { user, cart } = useSelector((state) => state);
  const [couponCode, setCouponCode] = useState(
    cart?.applyDiscountsApi?.discountCode || ""
  );
  const {
    mutateAsync: applyDiscountCodeMutationAsync,
    status: couponStatus,
    error: couponError
  } = useApplyDiscountsMutation();

  const [errorMessage, setErrorMessage] = useState("");

  function handleChange(e) {
    setCouponCode(e.target.value);
  }

  const updateCouponCode = useCallback(
    async ({ discountCode, loyaltyPoints }) => {
      setCouponCode(discountCode);
      await applyDiscountCodeMutationAsync({ discountCode, loyaltyPoints })
        .then(() => {
          setErrorMessage("");
          fireGtagEvent("coupon_applied", { couponCode: discountCode });
        })
        .catch((error) => {
          const message =
            error instanceof Error ? error.message : String(error);
          setErrorMessage(message);
        });
    },
    [applyDiscountCodeMutationAsync, couponCode]
  );

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && couponCode) {
      updateCouponCode({
        discountCode: !cart?.applyDiscountsApi?.discountCode ? couponCode : "",
        loyaltyPoints: cart?.applyDiscountsApi?.loyaltyPoints
      });
    }
  };

  if (!user.authToken || location.pathname.includes("payment")) return <div />;

  return (
    <div className="coupon-container">
      <div className="coupon-add">
        <div className="left-side-coupon">
          <img src={Discount} alt="" />
          <input
            type="text"
            value={couponCode}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Discount code"
            disabled={cart?.applyDiscountsApi?.discountCode}
          />
        </div>

        {couponStatus === "pending" ? (
          <button type="button" className="coupon-btn" aria-label="loading">
            <LoadingComponent diameter="20" color="#aaaaaa" />
          </button>
        ) : (
          <button
            type="button"
            className="coupon-btn"
            disabled={!couponCode}
            onClick={() =>
              updateCouponCode({
                discountCode: !cart?.applyDiscountsApi?.discountCode
                  ? couponCode
                  : "",
                loyaltyPoints: cart?.applyDiscountsApi?.loyaltyPoints
              })
            }
          >
            {cart?.applyDiscountsApi?.discountCode ? "Remove" : "Apply"}
          </button>
        )}
      </div>

      {(errorMessage || (couponStatus === "error" && couponError)) && (
        <ErrorTemplate
          error={
            errorMessage ||
            (couponError && couponError.message) ||
            "Something went wrong while applying the coupon."
          }
        />
      )}
    </div>
  );
}

export default CouponDiscount;
